import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center flex-col p-2 bg-slate-50 rounded-xl"
};
const _hoisted_2 = {
  class: "font-bold mb-2 text-lg"
};
const _hoisted_3 = {
  class: "flex items-stretch justify-center font-bold text-lg child:px-1.5"
};
const _hoisted_4 = {
  class: "flex-center bg-green-600 text-green-50 ml-0.5"
};
const _hoisted_5 = {
  class: "flex justify-center flex-wrap mt-2"
};
import Icon from "@/modules/vue/components/Icon.vue";
import GatePointDisplay from "@/modules/team/components/GatePointDisplay.vue";
import { AchievementTypeEnum } from "@/modules/archiements/enums";
import { translator } from "@/modules/vue/i18n";
export default /*#__PURE__*/_defineComponent({
  __name: 'Achievement',
  props: {
    achievement: null
  },
  emits: ['click:take-reward'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const label = computed(() => ({
      [AchievementTypeEnum.MATCH_WON]: translator.t('victories'),
      [AchievementTypeEnum.PLAYER_SELL]: translator.t('sell_player'),
      [AchievementTypeEnum.PLAYER_BUY]: translator.t('buy_player')
    })[props.achievement.type]);
    const onClickReward = () => {
      if (!props.achievement.achieved || props.achievement.rewarded) {
        return;
      }
      emit('click:take-reward');
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(label)), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(["flex-center rounded-tl rounded-bl", {
          'bg-slate-600 text-slate-50': !__props.achievement.achieved,
          'bg-green-600 text-green-50': __props.achievement.achieved
        }])
      }, _toDisplayString(__props.achievement.isMoney ? _ctx.$money(__props.achievement.currentValue) : _ctx.$n(__props.achievement.currentValue)), 3), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.achievement.isMoney ? _ctx.$money(__props.achievement.neededValue) : _ctx.$n(__props.achievement.neededValue)), 1), _createVNode(_component_NButton, {
        secondary: "",
        size: "small",
        type: __props.achievement.achieved && !__props.achievement.rewarded ? 'success' : 'default',
        class: "rounded-tr rounded-br rounded-tl-none rounded-bl-none ml-0.5",
        onClick: onClickReward
      }, {
        default: _withCtx(() => [__props.achievement.rewarded ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _ctx.IconEnum.CheckRound
        }, null, 8, ["icon"])) : (_openBlock(), _createBlock(Icon, {
          key: 1,
          icon: __props.achievement.achieved ? _ctx.IconEnum.Money20Regular : _ctx.IconEnum.CloseOutline
        }, null, 8, ["icon"]))]),
        _: 1
      }, 8, ["type"])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.achievement.rewards, (value, gateType) => {
        return _openBlock(), _createBlock(GatePointDisplay, {
          key: gateType,
          "gate-type": gateType,
          value: value,
          horizontal: "",
          class: "mb-0.5 mr-1 last:mr-0"
        }, null, 8, ["gate-type", "value"]);
      }), 128))])]);
    };
  }
});